// 更新loading状态
export const UPDATE_LOADING = 'loading/UPDATE_LOADING';
// 登录成功
export const LOGIN_SUCCESS = 'user/LOGIN_SUCCESS';
// 退出登录
export const LOGIN_OUT = 'user/LOGIN_OUT';
// 缓存产品信息
export const CACHE_PRODUCT_INFO = 'task/CACHE_PRODUCT_INFO';
// 临时登录账号
export const TEMP_LOGIN_PHONE = 'user/TEMP_LOGIN_PHONE';
// 是否是第一次进入app
export const IS_FIRST_IN = 'global/IS_FIRST_IN';
// tabbar显示状态
export const SHOW_TABBAR = 'global/SHOW_TABBAR';
// 退出登录并回退到主页通知
export const LOGOUT_TO_LOGIN = 'user/LOGOUT_TO_LOGIN';
// 更新实名状态
export const UPDATE_REALNAME_STATE = 'user/UPDATE_REALNAME_STATE';
// 更新授权状态
export const UPDATE_AUTHEN_STATE = 'user/UPDATE_AUTHEN_STATE';
// jPushID
export const JPUSHID = 'global/JPUSHID';
// 更新设置密码状态
export const UPDATE_SETTINGPWD_STATE = 'user/UPDATE_SETTINGPWD_STATE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js